import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="components--calendar"
export default class extends Controller {
  static targets = ["button", "calendar", "input"];
  static values = {
    popoverTarget: {
      type: String,
      default: `popover-${Math.floor(Math.random() * 10000)}`,
    },
    calendarInput: String,
  };

  connect() {
    this.buttonTarget.type = "button";
    this.buttonTarget.setAttribute("id",'id' + this.popoverTargetValue);
    this.buttonTarget.setAttribute("popovertarget", this.popoverTargetValue);
    this.buttonTarget.setAttribute("style", `anchor-name:--id${this.popoverTargetValue}`);

    this.calendarTarget.setAttribute("id",this.popoverTargetValue);
    this.calendarTarget.setAttribute("popover", '')
    this.calendarTarget.setAttribute("style", `position-anchor:--id${this.popoverTargetValue}`);

    const cally = this.calendarTarget.querySelector(".cally");

    cally?.addEventListener("change", (e) => {
      this.buttonTarget.innerText = e.target.value
      this.calendarInputValue = e.target.value
    })

    const initialRange = this.inputTarget.value || cally?.value || cally?.getAttribute("value");
    if (initialRange) {
      this.inputTarget.value = initialRange;
      this.buttonTarget.innerText = initialRange;
      if (cally && !cally.value) {
        cally.value = initialRange;
      }
    }
  }

  calendarInputValueChanged() {
    this.inputTarget.value = this.calendarInputValue;
  }
}
